import { render, staticRenderFns } from "./SupplierListCreate.vue?vue&type=template&id=a63229a0&scoped=true"
import script from "./SupplierListCreate.vue?vue&type=script&lang=js"
export * from "./SupplierListCreate.vue?vue&type=script&lang=js"
import style0 from "./SupplierListCreate.vue?vue&type=style&index=0&id=a63229a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a63229a0",
  null
  
)

export default component.exports